import React, { useState } from "react";

import "./ScheduledReports.css";
import Calendar from "../../../components/Calendar/Calendar";

const ScheduledReportsOverview = ({ scheduledReportsData }) => {
  const today = new Date();

  const [selectedDate, setSelectedDate] = useState(today);

  const getReportsForDate = (date) => {
    if (!date || !scheduledReportsData) return [];
    return scheduledReportsData.filter((report) => report.date.toDateString() === date.toDateString());
  };

  const formatSelectedDate = (date) => {
    const options = { weekday: "long", month: "short", day: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const filteredReports = getReportsForDate(selectedDate);

  const reportDates = scheduledReportsData?.map((report) => report.date) || [];

  return (
    <div className="scheduled-reports-container">
      <div className="scheduled-reports-left-section">
        <Calendar selectedDate={selectedDate} onDateSelect={setSelectedDate} reportDates={reportDates} />
      </div>

      <div className="scheduled-reports-right-section">
        <div className="scheduled-reports-header">
          <h3 className="scheduled-reports-title">Scheduled Reports</h3>
          <p className="scheduled-reports-subtitle">
            {selectedDate
              ? `${formatSelectedDate(selectedDate)} - ${filteredReports.length} ${
                  filteredReports.length === 1 ? "item" : "items"
                }`
              : "No date selected"}
          </p>
        </div>

        <div className="scheduled-reports-list">
          {filteredReports.length > 0 ? (
            filteredReports.map((report) => (
              <div key={report.id} className="scheduled-report-card">
                <div
                  className="scheduled-report-icon"
                  style={{
                    backgroundColor: report.iconBg,
                    color: report.iconColor,
                  }}
                >
                  {report.icon}
                </div>
                <div className="scheduled-report-details">
                  <div className="scheduled-report-title-row">
                    <h5 className="scheduled-report-title">{report.title}</h5>
                    <span className="scheduled-report-status-dot"></span>
                  </div>
                  <div className="scheduled-report-meta">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                      <circle cx="7" cy="7" r="6" stroke="currentColor" strokeWidth="1.5" />
                      <path d="M7 3.5V7L9.5 9.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    </svg>
                    <span className="scheduled-report-time">{report.time}</span>
                    <span className="scheduled-report-type">{report.type}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="scheduled-reports-no-reports">
              <p>No reports scheduled for this date</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ScheduledReportsOverview;
